import React, { Component } from 'react'
import {
  Editor,
  EditorState,
  RichUtils,
} from 'draft-js'
import '../assets/css/yomaEditor.css'
import Icon from '@material-ui/core/Icon';
import {
  stateFromHTML
} from 'draft-js-import-html'

const INLINE_STYLES = [
  { label: 'Bold', style: 'BOLD', icon: 'format_bold' },
  { label: 'Italic', style: 'ITALIC', icon: 'format_italic' },
  { label: 'Underline', style: 'UNDERLINE', icon: 'format_underlined' },
  { label: 'Monospace', style: 'CODE', icon: 'font_download' },
];

const BLOCK_TYPES = [
  { label: 'Title', style: 'header-four', icon: 'title' },
  { label: 'Blockquote', style: 'blockquote', icon: 'format_quote' },
  { label: 'InsertBullet', style: 'unordered-list-item', icon: 'format_list_bulleted' },
  { label: 'InsertNumberBullet', style: 'ordered-list-item', icon: 'format_list_numbered' },
];

class YomaEditor extends Component {
//this.state = {editorState: EditorState.createWithContent(ContentState.createFromText("<p>jd</p>"))};
  constructor(props) {
    super(props);
    
    const newState = EditorState.createEmpty()
    this.state = { editorState: newState};

    // this.focus = () => this.refs.editor.focus();

    this.onChange = (editorState) => {
      this.setState({ editorState: editorState})
    }

    this.handleKeyCommand = (command) => this._handleKeyCommand(command);
    this.onTab = (e) => this._onTab(e);
    this.toggleBlockType = (type) => this._toggleBlockType(type);
    // To Remove
    this.toggleInlineStyle = (style) => this._toggleInlineStyle(style);

  }

  componentWillReceiveProps(nextProps) {
  
    if(nextProps.value === undefined) {
      this.setState({ editorState: EditorState.createEmpty() })
    }else{
      this.setState({editorState: EditorState.createWithContent(stateFromHTML(nextProps.value))})
    }
    
  }
  

  render() {
    const { editorState } = this.state;
    const { placeholder } = this.props;
   
    let className = 'RichEditor-editor';
    var contentState = editorState.getCurrentContent();
    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== 'unstyled') {
        className += ' RichEditor-hidePlaceholder';
      }
    }

    return (
      <div className="RichEditor-root">
        <div style={{ display: 'inline-block' }}>
          <BlockStyleControls
            editorState={editorState}
            onToggle={this.toggleBlockType}
          />
          <InlineStyleControls
            editorState={editorState}
            onToggle={this.toggleInlineStyle}
          />
        </div>
        <div className={className} onClick={this.focus}>
          <Editor
            blockStyleFn={getBlockStyle}
            customStyleMap={styleMap}
            editorState={editorState}
            handleKeyCommand={this.handleKeyCommand}
            onChange={(editorState) => this.handleEditorState(editorState)}
            onTab={this.onTab}
            placeholder={placeholder}
            //   ref="editor"
            spellCheck={true}
          />
        </div>
      </div>
    )

  }

  handleEditorState(editorState) {

    this.setState({ editorState: editorState})

    this.props.onChange(editorState.getCurrentContent())

  }

  _handleKeyCommand(command) {
    const { editorState } = this.state;
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  }

  _onTab(e) {
    const maxDepth = 4;
    this.onChange(RichUtils.onTab(e, this.state.editorState, maxDepth));
  }

  _toggleBlockType(blockType) {
    this.onChange(
      RichUtils.toggleBlockType(
        this.state.editorState,
        blockType
      )
    )
  }

  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(
        this.state.editorState,
        inlineStyle
      )
    );
  }
}

const styleMap = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
};

function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote': return 'RichEditor-blockquote';
    default: return null;
  }
}


const BlockStyleControls = (props) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type) =>
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          icon={type.icon}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};


export default YomaEditor


class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    let className = 'RichEditor-styleButton';
    if (this.props.active) {
      className += ' RichEditor-activeButton';
    }

    return (
      <span className={className} onMouseDown={this.onToggle}>
        <Icon>{this.props.icon}</Icon>
      </span>
    );
  }
}


const InlineStyleControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map(type =>
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          icon={type.icon}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};